import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IProgramProspectsMetadata {
  id?: string;
  meta_desktop_icon?: string;
  meta_desktop_icon_alt?: string;
  meta_mobile_icon?: string;
  meta_mobile_icon_alt?: string;
  meta_title?: string;
  meta_title_text_color?: string;
  meta_description?: string;
  meta_description_text_color?: string;
  meta_desktop_card_color?: string;
  meta_mobile_card_color?: string;
  meta_priority?: number;
  meta_status?: boolean;
}

export interface IProgramProspects {
  id?: number;
  page_id?: number;
  component_id?: number;
  title?: string;
  title_text_color?: string;
  sub_title?: string;
  sub_title_text_color?: string;
  background_color?: string;
  variant?: string;
  status?: boolean;
  metadata?: IProgramProspectsMetadata[];
}

/**
 * Create program prospects entry
 */
export async function createProgramProspects(payload: Partial<IProgramProspects>) {
  try {
    const response = await adminAxios.post(ADMIN_API_ENDPOINTS.PROGRAM_PROSPECTS.CREATE,
      payload
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Update program prospects
 */
export async function updateProgramProspects(id: number, payload: Partial<IProgramProspects>) {
  try {
    const response = await adminAxios.put(ADMIN_API_ENDPOINTS.PROGRAM_PROSPECTS.UPDATE(id),
      payload
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Get program prospects by page ID
 */
export async function getProgramProspectsByPageId(pageId: number) {
  try {
    const response = await adminAxios.get(ADMIN_API_ENDPOINTS.PROGRAM_PROSPECTS.GET_BY_PAGE_ID(pageId)
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 404) {
      return null;
    }
    const errorResponse = handleApiError(axiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Delete program prospects
 */
export async function deleteProgramProspects(id: number) {
  try {
    const response = await adminAxios.delete(ADMIN_API_ENDPOINTS.PROGRAM_PROSPECTS.UPDATE(id)
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

